import { z } from 'zod';

export interface OneOnOneInsightsRequestI {
  isExpandedViewRequired: boolean;
  cohort: any;
  groupByKeys: Record<string, any>;
  orderBy: null;
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
  isShowReportees: boolean;
  isManagePage?: boolean;
  employeeId?: string;
  showReportees?: boolean;
}

export const OneOnOneInsightsColumnsValidator = z.object({
  id: z.string(),
  displayName: z.string(),
  description: z.string().nullable(),
  uuidType: z.string(),
  status: z.string().nullable(),
  calibrateAble: z.boolean(),
  filterTagType: z.string().nullable(),
  firstTimePinned: z.string().nullable(),
  category: z.string().nullable(),
});
